@if (answers?.length) {
<div class="free-text-answers-grid">
  @for (answer of answers; track answer.id) {
  <div class="answer-card">
    <div class="answer-text">
      {{ answer?.text }}
    </div>
  </div>
  }
</div>
}
